import { AfterViewInit, Component, inject, NgZone, OnDestroy, OnInit, WritableSignal } from '@angular/core';
import { MATERIAL_IMPORTS } from '../../../shared/shared-exports/material.exports';
import { CounterService } from '../../../services/counter-animation.service';
import { FormsModule } from '@angular/forms';
import { TRANSLATIONS_IMPORTS } from '../../../shared/shared-exports/translation.exports';
import { LoaderService } from '../../../services/loader-service';
import { AppStoreService } from '../../../store/ngrx-signal.store';

import { RouterLink } from '@angular/router';

interface Stat {
  label: string;
  value: number;
  displayValue: string;
  suffix?: string;
}

@Component({
  selector: 'app-hero-section',
  imports: [...MATERIAL_IMPORTS, ...TRANSLATIONS_IMPORTS, FormsModule, RouterLink],
  templateUrl: './hero-section.html',
  styleUrl: './hero-section.scss',
})
export class HeroSection implements OnInit, AfterViewInit, OnDestroy {
  selectSlide(index: number): void {
    this.activeIndex = index;
  }

  private storeService = inject(AppStoreService);
  isLoading = this.storeService.isLoadingSignal();
  constructor(
    private readonly counter: CounterService,
    private readonly ngZone: NgZone,
    public readonly loaderService: LoaderService,
  ) {}

  stats: Stat[] = [
    { label: 'Institutions Connected', value: 50, displayValue: '0+', suffix: '+' },
    { label: 'Active Projects', value: 120, displayValue: '0+', suffix: '+' },
    { label: 'Reporting Compliance', value: 95, displayValue: '0%', suffix: '%' },
  ];

  medias = [
    { imagePath: 'assets/images/bwawa-la-nyerere.jpg', title: 'Bwawa la Mwl Julius Nyerere' },
    { imagePath: 'assets/images/sgr-pic.jpeg', title: 'SGR Project' },
    { imagePath: 'assets/images/plantation-tz.jpg', title: 'Agricultural Projects' },
  ];

  activeIndex = 0;

  private intervalId: ReturnType<typeof setInterval> | null = null;

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.intervalId = setInterval(() => {
        this.ngZone.run(() => {
          this.activeIndex = (this.activeIndex + 1) % this.medias.length;
        });
      }, 3000);
    });

    this.stats.forEach((stat) => {
      this.counter.countTo(stat.value, 2000, (val) => {
        this.ngZone.run(() => {
          stat.displayValue = val + (stat.suffix ?? '');
        });
      });
    });
  }

  ngOnDestroy(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
    }
  }
}
